import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { TopTracks } from '@shared/components/top-tracks/top-tracks';
import { NgOptimizedImage } from '@angular/common';
import { PlaylistsStore } from '@data-access/user/stores/playlists.store';
import { MatPaginator } from '@angular/material/paginator';
import { Router } from '@angular/router';

@Component({
  selector: 'app-playlist',
  imports: [
    TopTracks,
    NgOptimizedImage,
    MatPaginator
  ],
  templateUrl: './playlists.html',
  styleUrl: './playlists.scss'
})
export class Playlists implements OnInit, OnDestroy {
  readonly playlistsStore = inject(PlaylistsStore);
  readonly router = inject(Router);

  ngOnInit() {
    this.playlistsStore.getFiltered();
  }

  ngOnDestroy() {
    this.playlistsStore.clearData();
  }

  changePlaylistsPage(page: {pageIndex: number; pageSize: number}) {
    this.playlistsStore.setPagination(page.pageIndex + 1, page.pageSize);
  }
  async selectPlaylist(playlistId: number, name: string) {
    const title = name.replace(/[^a-zA-Z0-9.]/g, '_');
    const id = `${playlistId}-${title}`
    this.router.navigate(['playlists', id]);
  }

}
